import { Injectable } from '@angular/core';
import { DELETABLE_LOCAL_STORAGE_ELEMENTS, ALL_LOCAL_STORAGE_ELEMENTS } from '../constants/storage-elements';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  addElement(data: any, key: string): void {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getElement(key: string): any {
    let tmp = sessionStorage.getItem(key);
    if(tmp) {
      tmp = JSON.parse(tmp);
    }

    return tmp;
  }

  public removeElement(key: string) {
    sessionStorage.removeItem(key);
  }

  clearStorage(clearAll?: boolean) {
    if (clearAll) {
      ALL_LOCAL_STORAGE_ELEMENTS.forEach(el => sessionStorage.removeItem(el));
    } else {
      DELETABLE_LOCAL_STORAGE_ELEMENTS.forEach(el => sessionStorage.removeItem(el));
    }
  }
}
